import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { toast } from "sonner";
import { UserRound, LogIn } from "lucide-react";

export default function PortalLoginPage() {
    const nav = useNavigate();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const { data } = await api.post("/portal/login", { username, password });
            localStorage.setItem("portal_token", data.token);
            localStorage.setItem("portal_employee", JSON.stringify(data.employee));
            toast.success(`Benvenuto ${data.employee.name}`);
            nav("/portal");
        } catch (e) {
            toast.error(formatApiError(e.response?.data?.detail) || "Accesso fallito");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="min-h-screen flex items-center justify-center px-4"
            style={{
                background:
                    "radial-gradient(ellipse at top, rgba(225,176,65,0.12), transparent 60%), #fafaf7",
            }}
            data-testid="portal-login-page"
        >
            <div className="w-full max-w-md">
                <div className="text-center mb-6">
                    <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-brand/15 text-navy text-xs font-medium mb-3">
                        <UserRound size={14} />
                        Portale Dipendenti
                    </div>
                    <h1 className="font-display text-3xl text-navy">
                        Sono un dipendente
                    </h1>
                    <p className="text-sm text-sf-secondary mt-1">
                        Accedi con le credenziali fornite dal tuo responsabile
                    </p>
                </div>
                <Card className="border-sf">
                    <CardHeader>
                        <CardTitle className="font-display">Accedi</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <form onSubmit={submit} className="space-y-3">
                            <div>
                                <Label htmlFor="username">Username</Label>
                                <Input
                                    id="username"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    placeholder="nome.cognome"
                                    autoComplete="username"
                                    data-testid="portal-username"
                                    required
                                />
                            </div>
                            <div>
                                <Label htmlFor="password">Password</Label>
                                <Input
                                    id="password"
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    autoComplete="current-password"
                                    data-testid="portal-password"
                                    required
                                />
                            </div>
                            <Button
                                type="submit"
                                className="w-full bg-navy text-white"
                                disabled={loading}
                                data-testid="portal-login-btn"
                            >
                                <LogIn size={14} className="mr-2" />
                                {loading ? "Accesso…" : "Accedi al portale"}
                            </Button>
                        </form>
                        <div className="text-xs text-sf-muted text-center mt-4">
                            Password dimenticata? Chiedi al responsabile di
                            rigenerarla nell&apos;anagrafica.
                        </div>
                    </CardContent>
                </Card>
                <div className="text-center mt-4">
                    <a
                        href="/"
                        className="text-xs text-sf-muted hover:underline"
                    >
                        ← Torna alla home
                    </a>
                </div>
            </div>
        </div>
    );
}
